(() => {
  const announcementBar = document.querySelector('.section-announcement-bar');
  const header = document.querySelector('.section-header');

  const updateAnnouncementBarHeight = () => {
    const height = announcementBar ? Math.ceil(announcementBar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--rendi-announcement-bar-height', `${height}px`);
  };

  updateAnnouncementBarHeight();
  window.addEventListener('resize', updateAnnouncementBarHeight);

  let lastScrollY = window.scrollY;
  let ticking = false;
  const SCROLL_DELTA_THRESHOLD = 8; // ignores tiny/jittery scroll deltas

  // Interacting with the Globo filter bar (opening a dropdown, focusing an
  // option) makes the browser scroll the focused element into view. That reads
  // as a scroll-up and popped the auto-hidden header back in mid-interaction.
  // Suppress the hide/show toggle briefly around any filter-bar interaction so
  // the header stays put while the shopper is using the filters.
  let suppressUntil = 0;
  const FILTER_BAR_SELECTOR = '#gf-tree, #gf-controls-container';
  ['pointerdown', 'focusin'].forEach((evt) => {
    document.addEventListener(
      evt,
      (event) => {
        const el = event.target;
        if (el && el.closest && el.closest(FILTER_BAR_SELECTOR)) {
          suppressUntil = performance.now() + 700;
        }
      },
      true
    );
  });

  const updateScrollState = () => {
    const currentScrollY = window.scrollY;

    if (performance.now() < suppressUntil) {
      // keep the header's current shown/hidden state during filter interaction
      lastScrollY = currentScrollY;
      ticking = false;
      return;
    }
    const delta = currentScrollY - lastScrollY;
    const combinedHeight =
      (announcementBar ? announcementBar.getBoundingClientRect().height : 0) +
      (header ? header.getBoundingClientRect().height : 0);

    if (currentScrollY <= combinedHeight) {
      // Never hide near the top — avoids a jarring hide right as the page loads.
      document.documentElement.classList.remove('rendi-header-hidden');
    } else if (delta > SCROLL_DELTA_THRESHOLD) {
      document.documentElement.classList.add('rendi-header-hidden');
    } else if (delta < -SCROLL_DELTA_THRESHOLD) {
      document.documentElement.classList.remove('rendi-header-hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  updateScrollState();
  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateScrollState);
    },
    { passive: true }
  );
})();
